import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/teams/$id/members")({
	component: RouteComponent,
});

function RouteComponent() {
	return <Outlet />;
}
